module.exports = __webpack_public_path__ + "static/media/middleRiskBg.8e5dffb0.png";